import { useState } from "react";
import reloadingArrow from "../assets/reloading-arrow-white.png";
import sound from "../assets/volume.png";
import noSound from "../assets/no-sound.png";
import arabic from "../assets/arabic.png";
import english from "../assets/english.png";
import close from "../assets/close.png";

import "./DhamaSetting.scss";

const DhamaSetting = (props) => {
  // const [isVisible, setIsVisible] = useState(true);
  const [replayisVisible, setReplayIsVisible] = useState(false);

  let language = props.language;
  let setLanguage = props.setLanguage;
  let activeSound = props.activeSound;
  let setActiveSound = props.setActiveSound;

  let isContainerVisibleMobile = props.isContainerVisibleMobile;
  let setContainerVisibleMobile = props.setContainerVisibleMobile;

  function toggleVisibilety() {
    // setIsVisible(!isVisible);
    setContainerVisibleMobile(!isContainerVisibleMobile);
  }
  function toggleActiveSound() {
    setActiveSound(!activeSound);
  }

  function toggleLanguage(selectedLanguage) {
    setLanguage(selectedLanguage);
  }

  function closeTheSettingTab() {
    setContainerVisibleMobile(!isContainerVisibleMobile);
  }
  function replyGameToggle() {
    setReplayIsVisible(!replayisVisible);
  }
  function replyGame() {
    window.location.reload();
  }
  return (
    <div className="container-left">
      <button onClick={toggleVisibilety}>
        {language === "ar" ? "الإعدادات" : "Setting"}
      </button>
      {/* {(isVisible || isContainerVisibleMobile) && ( */}
      <div className={`container ${isContainerVisibleMobile ? "visible" : ""}`}>
        <img src={close} className="close-img" onClick={closeTheSettingTab} />
        <div className="Language">
          <div className="Language-ARB-ENG">
            Arabic
            <img
              src={arabic}
              className={`rotate-on-hover-img arabicClass ${
                language === "ar" ? "" : "gray-image"
              }`}
              onClick={() => toggleLanguage("ar")}
            />
          </div>
          <div className="Language-ARB-ENG">
            English
            <img
              src={english}
              className={`rotate-on-hover-img englishClass ${
                language === "en" ? "" : "gray-image"
              }`}
              onClick={() => toggleLanguage("en")}
            />
          </div>
        </div>
        <div className="sound">
          {activeSound ? (
            <img
              src={sound}
              className="rotate-on-hover-img"
              onClick={toggleActiveSound}
            />
          ) : (
            <img
              src={noSound}
              className="rotate-on-hover-img"
              onClick={toggleActiveSound}
            />
          )}
        </div>
        <img
          src={reloadingArrow}
          className="rotate-on-hover-img"
          onClick={replyGameToggle}
        />
        {replayisVisible && (
          <div className="replay-the-game">
            {language === "ar"
              ? "إعادة اللعبة من البداية؟"
              : "Replay the game ?"}
            <div className="replay-the-game-button">
              <div onClick={replyGameToggle}>
                {language === "ar" ? "لا" : "No"}
              </div>
              <div onClick={replyGame}>{language === "ar" ? "نعم" : "Yes"}</div>
            </div>
          </div>
        )}
      </div>
      <div className="eat-more">
        {language === "ar" ? "استمر في الأكل" : "Continue eating"}
      </div>
      <div className="must-eat">
        {language === "ar" ? "لا يمكن تجاهل الأكل" : "Eating cannot be ignored"}
      </div>
      {/* <div className="choose-must-eat">
        {language === "ar"
          ? "اختر  الخانة اللتي تريد الاكل منها"
          : "Choose the box you want to eat from"}
      </div> */}
    </div>
  );
};

export default DhamaSetting;
